import { Box, styled } from '@mui/material';

export const CardHeaderStyled = styled(Box)({
  width: '100%',
  padding: '16px',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '6px',
});

export const StyledBox = styled(Box)({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  mr: '8px',
});
